import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';

export interface MenuItem {
  label: string;
  target: string[];
  fragment?: string;
  icon?: string;
  external?: boolean;
  href?: string;
}

@Component({
  selector: 'app-mobile-menu',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  animations: [
    trigger('slideUpDown', [
      state('closed', style({
        transform: 'translateY(100%)',
        opacity: 0
      })),
      state('open', style({
        transform: 'translateY(0)',
        opacity: 1
      })),
      transition('closed => open', [
        animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ]),
      transition('open => closed', [
        animate('250ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ])
    ]),
    trigger('backdropFade', [
      state('closed', style({
        opacity: 0
      })),
      state('open', style({
        opacity: 1
      })),
      transition('closed => open', [
        animate('200ms ease-out')
      ]),
      transition('open => closed', [
        animate('150ms ease-in')
      ])
    ])
  ]
})
export class MobileMenuComponent {
  @Input() isOpen = false;
  @Output() closeMenu = new EventEmitter<void>();

  menuItems: MenuItem[] = [
    {
      label: $localize`Contact us`,
      target: ['/help'],
      fragment: 'talk-to-us',
      icon: 'help'
    },
    {
      label: $localize`Be an ambassador`,
      target: ['/ambassador-program'],
      icon: 'star'
    },
    {
      label: $localize`List your hostel`,
      target: [],
      external: true,
      href: 'https://admin.hostelhop.io',
      icon: 'home'
    },
    {
      label: $localize`About us`,
      target: ['/about-us'],
      icon: 'info'
    },
    {
      label: $localize`Rewards`,
      target: ['/rewards'],
      icon: 'gift'
    },
    {
      label: $localize`Partners`,
      target: ['/partners'],
      icon: 'handshake'
    },
    {
      label: $localize`Blog`,
      target: ['/blog'],
      icon: 'article'
    },
    {
      label: $localize`Careers`,
      target: ['/careers'],
      icon: 'work'
    },
    {
      label: $localize`FAQ`,
      target: ['/help'],
      icon: 'question'
    }
  ];

  onBackdropClick() {
    this.closeMenu.emit();
  }

  onMenuItemClick() {
    this.closeMenu.emit();
  }

  getAnimationState() {
    return this.isOpen ? 'open' : 'closed';
  }
}
